/** Max chapter number per canonical book key (matches bible-api folder names). */
export const bibleBookChapterCounts: Readonly<Record<string, number>> = {
  genesis: 50,
  exodus: 40,
  leviticus: 27,
  numbers: 36,
  deuteronomy: 34,
  joshua: 24,
  judges: 21,
  ruth: 4,
  firstSamuel: 31,
  secondSamuel: 24,
  firstKings: 22,
  secondKings: 25,
  firstChronicles: 29,
  secondChronicles: 36,
  ezra: 10,
  nehemiah: 13,
  esther: 10,
  job: 42,
  psalms: 150,
  proverbs: 31,
  ecclesiastes: 12,
  solomon: 8,
  isaiah: 66,
  jeremiah: 52,
  lamentations: 5,
  ezekiel: 48,
  daniel: 12,
  hosea: 14,
  joel: 3,
  amos: 9,
  obadiah: 1,
  jonah: 4,
  micah: 7,
  nahum: 3,
  habakkuk: 3,
  zephaniah: 3,
  haggai: 2,
  zechariah: 14,
  malachi: 4,
  matthew: 28,
  mark: 16,
  luke: 24,
  john: 21,
  acts: 28,
  romans: 16,
  firstCorinthians: 16,
  secondCorinthians: 13,
  galatians: 6,
  ephesians: 6,
  philippians: 4,
  colossians: 4,
  firstThessalonians: 5,
  secondThessalonians: 3,
  firstTimothy: 6,
  secondTimothy: 4,
  titus: 3,
  philemon: 1,
  hebrews: 13,
  james: 5,
  firstPeter: 5,
  secondPeter: 3,
  firstJohn: 5,
  secondJohn: 1,
  thirdJohn: 1,
  jude: 1,
  revelation: 22,
};

export const bibleBookKeys = Object.keys(bibleBookChapterCounts);
